import React, { useState, useEffect } from 'react';
import clienteAxios from '../../../../config/axios';
import '../vistas.scss';
import Spin from '../../../../components/Spin';
import Card_Producto from '../../Productos/Cards_Normales/card_producto';

function Scroll(props) {
	const [ productos, setProductos ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const producto = props.productos;

	useEffect(() => {
		setLoading(true);
		clienteAxios
			.get(`/productos/search?nombre=${producto.nombre}&categoria=${producto.categoria}&subcategoria=${producto.subCategoria}`)
			.then((res) => {
				setProductos(res.data.posts);
				setLoading(false);
			})
			.catch((err) => {
				
			});
	}, [producto]);

	const render = productos.map((productos) => (
		<div key={productos._id} className="d-inline-flex mx-2 contenedor-card-tamaño">
			<Card_Producto productos={productos} />
		</div>
	));

	return (
		<Spin spinning={loading}>
			<div className="mt-5">
				<p className="font-prin titulos-vista-productos producto-descripcion mb-3">Quienes vieron este producto también compraron</p>
				<div className="contenedor-scroller">
					{render}
				</div>
			</div>
		</Spin>
	);
}

export default Scroll;
